import React from "react";
import { connect } from 'react-redux'

import client from '../../services/client';

import { logInAsync } from '../../redux/actions/user.actions';
import { resetPasswordAsync } from '../../redux/actions/account-management.actions';

class VerifySignup extends React.Component {
    constructor() {
        super();
    }

    componentDidMount() {
        const mockedUrl = window.location.href.replace(/#\/confirm/g,"");
        const url = new URL(mockedUrl);
        const token = url.searchParams.get("token");

        this.props.resetPasswordAsync({ 
            action: 'verifySignupLong',
            value: token
        });
    }

    render() {
        return (
            <main className="login-page">
                <div className="login">
                    <img className="intro-image" src="assets/landingpage-2-b.png"/>

                    <div className="login-main-bar main-bar">
                        <div className="login-button" onClick={()=> (window.location.href = '/')}>
                            Your email is verified! Feel free to log in.
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}

export default connect(
    null,
    { resetPasswordAsync }
)(VerifySignup);